import { Content } from './content';

export class Actuality extends Content {

    static tableName = 'actualities'
    
}